module.exports = __webpack_public_path__ + "img/Card_club_K.779de566.svg";